(function () {
  const COLLECTION_URL = "/collections/stationery-copy";

  // Habitat cart drawer selectors
  const DRAWER_SELECTOR =
    '[id*="cart"][id*="drawer" i], [class*="cart"][class*="drawer" i], [data-cart-drawer]';

  // Standard Shopify checkout buttons
  const CHECKOUT_SELECTOR =
    'button[name="checkout"], input[name="checkout"], a[href="/checkout"], a[href^="/checkout?"]';

  let pendingCheckout = null;

  // Create the popup once
  const dialog = document.createElement("dialog");
  dialog.id = "greeting-card-popup";

  dialog.innerHTML = `
    <div class="gcp-content">
      <button class="gcp-close" aria-label="Close popup">&times;</button>

      <p class="gcp-eyebrow">A LITTLE SOMETHING EXTRA</p>

      <h2>Want to add a greeting card?</h2>

      <p>
        Browse our greeting cards and add a personal touch to your gift! 
        Use code ADDACARD to get any greeting card for just $5.
      </p>

      <a class="gcp-shop" href="${COLLECTION_URL}">
        Shop Greeting Cards
      </a>

      <button class="gcp-continue" type="button">
        No thanks, continue to checkout
      </button>
    </div>
  `;

  document.body.appendChild(dialog);

  // Popup styling
  const style = document.createElement("style");
  style.textContent = `
    #greeting-card-popup {
      width: min(90%, 460px);
      max-width: 460px;
      padding: 0;
      border: none;
      border-radius: 12px;
      box-shadow: 0 10px 50px rgba(0,0,0,.2);
      color: #333;
    }

    #greeting-card-popup::backdrop {
      background: rgba(0,0,0,.55);
    }

    .gcp-content {
      position: relative;
      padding: 48px 36px 36px;
      text-align: center;
    }

    .gcp-close {
      position: absolute;
      top: 12px;
      right: 16px;
      border: none;
      background: none;
      font-size: 28px;
      cursor: pointer;
      color: inherit;
    }

    .gcp-eyebrow {
      font-size: 11px;
      letter-spacing: 2px;
      margin-bottom: 14px;
    }

    .gcp-content h2 {
      font-size: 28px;
      line-height: 1.2;
      margin: 0 0 16px;
    }

    .gcp-content p:not(.gcp-eyebrow) {
      font-size: 15px;
      line-height: 1.6;
      margin-bottom: 24px;
    }

    .gcp-shop {
      display: block;
      padding: 15px 20px;
      background: #1D283C;
      color: #fff;
      text-decoration: none;
      margin-bottom: 16px;
      font-size: 14px;
      font-weight: 600;
    }

    .gcp-continue {
      border: none;
      background: none;
      text-decoration: underline;
      font-size: 13px;
      cursor: pointer;
      color: inherit;
    }

    @media (max-width: 480px) {
      .gcp-content {
        padding: 44px 24px 28px;
      }
    }
  `;

  document.head.appendChild(style);

  function openPopup(checkoutButton) {
    pendingCheckout = checkoutButton;
    dialog.showModal();
  }

  function continueToCheckout() {
    const checkoutButton = pendingCheckout;
    pendingCheckout = null;

    dialog.close();

    if (!checkoutButton) return;

    // If checkout is a link, navigate directly.
    if (checkoutButton.tagName === "A") {
      window.location.href = checkoutButton.href;
      return;
    }

    // Otherwise submit the original Shopify checkout form.
    const form =
      checkoutButton.form ||
      checkoutButton.closest("form");

    if (form) {
      form.requestSubmit(checkoutButton);
    } else {
      window.location.href = "/checkout";
    }
  }

  // Intercept checkout clicks inside the cart drawer.
  document.addEventListener("click", function (event) {
    const target = event.target instanceof Element
      ? event.target
      : event.target.parentElement;

    if (!target) return;

    const checkoutButton = target.closest(CHECKOUT_SELECTOR);

    if (!checkoutButton) return;

    const drawer = checkoutButton.closest(DRAWER_SELECTOR);

    if (!drawer) return;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    openPopup(checkoutButton);
  }, true);

  // Continue to checkout
  dialog.querySelector(".gcp-continue")
    .addEventListener("click", continueToCheckout);

  // Close popup
  dialog.querySelector(".gcp-close")
    .addEventListener("click", function () {
      dialog.close();
    });

  // Close when clicking outside the popup
  dialog.addEventListener("click", function (event) {
    if (event.target === dialog) {
      dialog.close();
    }
  });

})();